import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatorService } from '../core/translator/translator.service';
import { MenuService } from '../core/menu/menu.service';
import { SharedModule } from '../shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { SortDirective } from './../directive/sort.directive';
import { ResizableDirective } from './../directive/resizable.directive';
import { routes } from './routes';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { menu } from './menu';
import { CandidateDetailsComponent } from './master/candidate-details/candidate-details.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes, { useHash: true }),
        PagesModule,
        Ng2SearchPipeModule,
        MatButtonModule,
        ReactiveFormsModule
    ],
    declarations: [ SortDirective, ResizableDirective,   CandidateDetailsComponent  ],
    exports: [
        RouterModule,
       
    ]
})
export class RoutesModule {
    constructor(public menuService: MenuService, tr: TranslatorService) {
        menuService.addMenu(menu);
    }
}
